import React, { useEffect, useRef, useState } from "react";
import "./index.less";
import { Button, Form, Input, Modal, Radio } from "antd";
import { checkActiviteSignup, getActivityDetail, saveActiviteSignup } from "@/api/activite";
import Success from "@/assets/images/expense/success.png";
import { useLocation, useNavigate } from "react-router-dom";
import { QuestionStatus } from "@/types/message";
const prefix = "activite-signup";


const activiteTips=[
  '温馨提示:',
  '1.数据备份提醒:本次适配x86的KaihongOs桌面版可能会造成原有数据丢失，请升级前做好数据备份。',
  '2.参与本次Beta体验设备要求:',
  'CPU:1GHz以上，支持64位处理器(双核或多核)或系统单芯片(SoC)，保证系统流畅运行。',
  'RAM:至少4GB的RAM。',
  '存储:30GB以上可用独立分区空间，支持SATA、NVME。',
  '系统固件:支持从外部USB引导的UEFI系统固件。',
  '显卡:OpenGLES3.0或更高版本的显卡。'
];
const activiteDes=[
  '国内首个开源鸿蒙桌面操作系统——KaihongOS桌面版，成功适配x86设备，为国产操作系统的发展开辟了新路径。我们诚邀您参与本次体验计划，深度体验KaihongOS桌面版，包括系统安装、卸载，以及开源鸿蒙原生应用体验，全方位感受系统的独特魅力。',
  '报名周期：06月30日- 07月15日',
  '审核周期：07月10日- 07月30日，具体请以实际审核时间为准，请您耐心等待。 后续报名开放情况，请关注官方消息。'
];
const activiteTitle='KaihongOS桌面版成功适配x86设备，诚邀开发者 Beta体验报名';

const ActiviteSignUp: React.FC = () => {
  const [form] = Form.useForm();
  const navgiate=useNavigate();
  const location=useLocation();
  const formList = useRef<any>([
    { label: "1.姓名", name: "surveyUserName", placeholder: "请输入姓名", type: "input", inputType: "text", required: true ,maxLength:64 },
    { label: "2.联系电话", name: "surveyContact", placeholder: "请输入您的联系电话", type: "input", inputType: "text", required: true,maxLength:15 },
    { label: "3.邮箱地址", name: "surveyEmail", placeholder: "请输入您的邮箱地址", type: "input", inputType: "text", required: true,maxLength:256 },
    { label: "4.公司名称/学校名称", name: "surveyOrganizationName", placeholder: "请输入您的公司名称/学校名称", type: "input", inputType: "text", required: true ,maxLength:256 },
    { label: "5.所属职业/身份", name: "surveyIdentity", placeholder: "请输入您的所属职业/身份", type: "input", inputType: "text", required: true,maxLength:256 },
    { label: "6.是否了解开源鸿蒙", name: "isKnow",  type: "radio",placeholder: "请选择是否了解开源鸿蒙",  required: true,options:[
      { value: "了解", label: "了解" },
      { value:  "熟悉", label: "熟悉" },
      { value:"不了解", label: "不了解" },
    ]},
    { label: "7.是否有开源鸿蒙的开发经验？有的话请详细描述？", name: "surveyExperience", placeholder: "请输入描述", type: "textarea", required: true,maxLength:999 },
  ]);
  const [activiteDetail, setActiviteDetail] = useState<any>({})
  const [submitModalVisible, setSubmitModalVisible] =useState(false);
  const [isSignup, setIsSignup]=useState(false);
  const code=useRef<any>(null);
  const closeModal=()=>{
    setSubmitModalVisible(false);
    navgiate('/activity/x86-beta');
  }
  const submit=(values: any) => {
    
    console.log(values);
    const surveyAnswersDetailList=formList.current.map((item:any,index:number)=>{
      return {
        "answerText": values[item.name],
        "questionName": item.label,
        "sortOrder": index+1
      }
    })
    const params={
      ...values,
      surveyAnswersDetailList: surveyAnswersDetailList,
      surveyCode: activiteDetail.code,
      surveyId: activiteDetail.id,
      surveyName:activiteDetail.name,
      type: activiteDetail.type
    }

    saveActiviteSignup(params).then((res)=>{
      console.log(res);
      if(res.code==200){
        form.resetFields();
        setIsSignup(true);
        setSubmitModalVisible(true);
      }else{
        window.message?.error(res.message);
      }
    }).catch((err)=>{
      console.error(err);
      if(err?.message){
        window.message?.error(err.message);
      }
    })
  }
  /**
   * 校验是否已经报名
   * @returns 
   */
  const checkActiviteSignupStatus=()=>{
    return new Promise((resolve,reject)=>{
      checkActiviteSignup(code.current).then((res)=>{
        console.log(res);
        if(res.code==200){
          setIsSignup(res.result);
          resolve(res.result);
        }else{
          reject(res.message);
        }
      }).catch((err)=>{
        console.error(err)

      })
    })
  }
  const submitText=()=>{
    let str='';
    if(activiteDetail?.status==QuestionStatus.IN_PROGRESS){
      str= isSignup?'已报名':'提交'
    }else if(activiteDetail?.status==QuestionStatus.END){
      str='活动已结束'
    }else if(activiteDetail?.status==QuestionStatus.NOT_START){
      str='活动未开始'
    }else{
      str='提交'
    }
    return str
  }
  const getActivite=()=>{
    getActivityDetail(code.current ).then((res)=>{
      console.log(res);
      if(res.code==200){
        setActiviteDetail(res.result)
      }
    }).catch((err)=>{
      console.error(err)
    })
  }
  useEffect(() => {
    const urlSearch=new URLSearchParams(location.search);
     code.current=urlSearch.get("code") || 'KaihongOS_x86_Beat';
    getActivite();
    checkActiviteSignupStatus();
    return () => {
      // 清空表单
      formList.current = [];
    };
  }, []);
  return (
    <div className={`${prefix}`}>
      <div className={`${prefix}-banner`}>
        <img src={require("../../../../assets/images/activite-banner.png")} alt="" />
        <div className={`${prefix}-banner-shadow`}>
        </div>
      </div>
      <div className={`${prefix}-content`}>
        <div className={`${prefix}-title`}>
          <h2>{activiteTitle}</h2>
          {activiteDes.map((item,index)=>{
              return <p key={index}>{item}</p>
            })
          }
        </div>
        <Form className={`${prefix}-form`} form={form} onFinish={submit}>
          <div className={`${prefix}-form-item`}>
            {formList.current.map((item: any, index: number) => {
              return (
                <Form.Item key={index} label={item.label} name={item.name} required={item.required} rules={[{ required: true, message: item.placeholder }]}>
                  {item.type === "input" && <Input type={item.inputType || "text"} maxLength={item.maxLength || 64} placeholder={item.placeholder} />}
                  {item.type === "radio" && (
                    <Radio.Group
                      options={item.options}
                    />
                  )}
                  {item.type === "textarea" && <Input.TextArea maxLength={item.maxLength || 1000} placeholder={item.placeholder} autoSize={{ minRows: 5, }} /> }
                </Form.Item>
              );
            })}
          </div>
          <div className={`${prefix}-form-des`}>   
            {activiteTips.map((item,index)=>{
              return <p key={index}>{item}</p>
            })
            }
          </div>
          <Form.Item>
            <div className={`${prefix}-form-submit`}>
              <Button type="primary" disabled={activiteDetail?.status!=QuestionStatus.IN_PROGRESS || isSignup} htmlType="submit">
                {submitText()}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>

      <Modal open={submitModalVisible} 
        centered
        maskClosable={false}
        onCancel={closeModal}
        footer={null}
        className='payment-modal'
      >
        <div className={`payment-modal-content signup-dialog`}>
            <img src={Success} alt="" />
            <div className="payment-modal-des ">
              <p>提交成功</p>
              <p>请您耐心等待。 后续报名开放情况，请关注官方消息。</p>
            </div>
            <Button type="primary"  onClick={closeModal}>确定</Button>
        </div>
      </Modal>
    </div>
  );
};

export default ActiviteSignUp;
